<abs-modals-and-alerts-component [(modalAction)]="openModal" (modalClosed)="close($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component id="session-timeout-utf-modal-popup" class="modal-size">
    <main class="modal-header" tabindex="0">
      <h1 style="display:none;">Sonar Fix</h1>
      <h2 id="session-timeout-utf-modal-heading">{{cfetLabels.utf_session_time_out_modal.heading}}
      </h2>
      <div class="corner-button">
        <button type="button" id="close-btn" class="close-modal-button" tabindex="0" [attr.aria-label]="'Close'"
          (click)="close($event, 'openModal')" (keyup)="close($event,'openModal')">
          <em aria-label="Close" id="icon-close" class="icon-close modal-close-icon" role="img"></em>
        </button>
      </div>
    </main>
    <section class="modal-body" id="modal-body-section" modal-content tabindex="0">
      <p id="description1" [innerHTML]="cfetLabels. utf_session_time_out_modal.description1"></p>
      <p id="description2" [innerHTML]="cfetLabels. utf_session_time_out_modal.description2"></p>
      <div class="row no-gutters" id="close-buttons">
        <button type="button" id="btn-utf" (click)="close($event,'openModal')" (keyup)="close($event,'openModal')"
          class="btn btn-alt btn-medium" tabindex="0"><em aria-label=""></em>
          {{cfetButtonLabels.button_labels.close}}</button>
      </div>
    </section>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>